import { ParameterConflict } from "store/api/generatedApi";

interface ConflictReason {
  key: string;
  conflict: ParameterConflict;
  chefGroupIds: number[];
}

export const groupConflictReasons = (
  conflicts: ParameterConflict[]
): ConflictReason[] => [
  ...conflicts
    .reduce((reasons, conflict) => {
      const key = JSON.stringify([
        conflict.kind,
        conflict.coefficients_signature,
        conflict.basket_number,
        conflict.chemical_constraint_name,
        conflict.material_name,
        conflict.required_mass,
        conflict.available_mass,
        conflict.required_volume,
        conflict.available_volume,
        conflict.achievable_weight_percent,
        conflict.tolerance_weight_percent,
        conflict.max_failure_rate,
      ]);
      const previous = reasons.get(key);
      return new Map(reasons).set(key, {
        key,
        conflict: {
          ...conflict,
          steel_grade_names: [
            ...new Set([
              ...(previous?.conflict.steel_grade_names ?? []),
              ...conflict.steel_grade_names,
            ]),
          ],
        },
        chefGroupIds: [
          ...new Set([
            ...(previous?.chefGroupIds ?? []),
            conflict.chef_group_id,
          ]),
        ],
      });
    }, new Map<string, ConflictReason>())
    .values(),
];
